<script setup>
import { computed, inject } from "vue";
import { usePage } from "@inertiajs/vue3";
import { useI18n } from "vue-i18n";

const route = inject("route");
const { t } = useI18n();
</script>

<template>
  <div class="relative w-full h-screen flex items-center justify-start">
    <!-- Image as the background with <img> tag -->
    <img
      src="@/../img/home/doctor-team.png"
      alt="Background"
      class="absolute w-full h-full object-cover rounded-lg shadow-lg"
    />

    <!-- Black Overlay covering full screen -->
    <div class="absolute inset-0 bg-black bg-opacity-80"></div>

    <!-- Content Box (Left-Aligned & Full Height) -->
    <div class="section-container">
      <div
        class="relative z-10 flex flex-col justify-center items-start w-full text-left text-white h-full px-10"
      >
        <h1
          class="text-4xl md:text-5xl text-white"
        >{{ $t('Het platform voor flexibel werken in de zorg') }}</h1>
        <p
          class="mt-5 text-lg md:text-xl font-semibold text-white"
        >{{ $t('Met Zorgblik zorg jij heel eenvoudig & transparant dat jouw bezetting op orde is!') }}</p>
      </div>
    </div>
  </div>
</template>
